import React, { useState } from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import {
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  Box,
  Typography,
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import LogoImg from "../../../images/LOGO.svg";
import LogoTitle from "../../../images/LOGO_Title.svg";
import { useUserStore } from "../../../store/UserStore";

function Navbar() {
  const navigate = useNavigate();
  const user = useUserStore((state) => state.user);
  const setUser = useUserStore((state) => state.setUser);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const returnToHome = () => {
    navigate("/");
  };

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const handleManageBillingClick = async (event) => {
    event.preventDefault();

    window.open(
      "https://rawdat.ai/login/portal/customer/portal-session",
      "_blank",
      "noopener,noreferrer"
    );
  };

  const drawerList = () => (
    <Box
      sx={{ width: 250 }}
      role="presentation"
      onClick={toggleDrawer(false)}
      onKeyDown={toggleDrawer(false)}
    >
      <List>
        {[
          { title: "Home", path: "/", show: !user ? true : false },
          { title: "Company", path: "/about", show: true },
          { title: "Product", path: "/product", show: true },
          {
            title: "Serverless Computing",
            path: "/serverless-computing",
            show: user ? true : false,
          },
          {
            title: "Subscribe",
            path: "/subscribe",
            show: !user ? true : false,
          },
          {
            title: "Manage Billing",
            path: "/manage-billing",
            show: user ? true : false,
          },
          { title: "Log in", path: "/login", show: !user ? true : false },
          { title: "Log out", path: "/logout", show: user ? true : false },
        ].map((link, index) => {
          return (
            <ListItem
              sx={{ display: link.show ? "block" : "none" }}
              key={index}
              component={NavLink}
              to={link.path}
              onClick={
                link.title === "Manage Billing"
                  ? handleManageBillingClick
                  : null
              }
            >
              <ListItemText
                sx={{ display: link.show ? "block" : "none", color: "#fff" }}
                primary={link.title}
              />
            </ListItem>
          );
        })}
      </List>
    </Box>
  );

  return (
    <div className="navbar">
      <div className="maxWidth">
        <div
          style={{ display: "flex", gap: "1.5rem", cursor: "pointer" }}
          onClick={returnToHome}
        >
          <img src={LogoImg} alt="LOGO" />
          <img src={LogoTitle} alt="RAWDAT" />
        </div>
        <div className="navbar-links">
          {!user && <NavLink to="/">Home</NavLink>}
          <NavLink to="/about">Company</NavLink>
          <NavLink to="/product">Product</NavLink>
          {user && (
            <NavLink to="/serverless-computing">Serverless Computing</NavLink>
          )}
          {!user && <NavLink to="/subscribe">Subscribe</NavLink>}
          {!user && <NavLink to="/login">Log in</NavLink>}
          {user && (
            <NavLink to="/manage-billing" onClick={handleManageBillingClick}>
              Manage Billing
            </NavLink>
          )}

          {user && <NavLink to="/logout">Logout</NavLink>}
        </div>
        <IconButton
          className="hamburger"
          color="inherit"
          aria-label="open drawer"
          edge="end"
          onClick={toggleDrawer(true)}
          sx={{ ml: "auto", color: "white" }}
        >
          <MenuIcon />
        </IconButton>
        <Drawer
          sx={{
            "& .MuiDrawer-paper": {
              backgroundColor: "#000",
              "& ul": {
                color: "#fff",
                display: "flex",
                gap: "2rem",
                flexDirection: "column",
                paddingTop: "2rem",
              },
            },
          }}
          anchor="right"
          open={drawerOpen}
          onClose={toggleDrawer(false)}
        >
          {drawerList()}
        </Drawer>
      </div>
    </div>
  );
}

export default Navbar;
